/**
 * Index principal des styles du widget Ringado
 * Importe et combine tous les styles modulaires
 */

// Base
import { RESET_STYLES } from './base/reset.js';
import { POSITIONING_STYLES } from './base/positioning.js';

// Composants
import { CHAT_BUTTON_STYLES } from './components/chat-button.js';
import { CHAT_MODAL_STYLES } from './components/chat-modal.js';
import { CHAT_HEADER_STYLES } from './components/chat-header.js';
import { MESSAGES_STYLES } from './components/messages.js';
import { INPUT_AREA_STYLES } from './components/input-area.js';
import { FOOTER_STYLES } from './components/footer.js';

// Animations
import { ANIMATIONS_STYLES } from './animations/keyframes.js';

// Utilitaires
import { TRANSITIONS_STYLES } from './utils/transitions.js';
import { RESPONSIVE_STYLES } from './utils/responsive.js';
import { DEVICE_SPECIFIC_STYLES } from './utils/device-specific.js';

/**
 * Styles CSS complets pour le widget Ringado
 * Reproduction exacte des styles de ChatSystem.vue et ChatModal.vue
 */
export const WIDGET_STYLES = [
  RESET_STYLES,
  POSITIONING_STYLES,
  CHAT_BUTTON_STYLES,
  CHAT_MODAL_STYLES,
  CHAT_HEADER_STYLES,
  MESSAGES_STYLES,
  INPUT_AREA_STYLES,
  FOOTER_STYLES,
  ANIMATIONS_STYLES,
  TRANSITIONS_STYLES,
  RESPONSIVE_STYLES,
  DEVICE_SPECIFIC_STYLES,
].join('\n');

// Export individuel des styles pour une utilisation modulaire
export {
  RESET_STYLES,
  POSITIONING_STYLES,
  CHAT_BUTTON_STYLES,
  CHAT_MODAL_STYLES,
  CHAT_HEADER_STYLES,
  MESSAGES_STYLES,
  INPUT_AREA_STYLES,
  FOOTER_STYLES,
  ANIMATIONS_STYLES,
  TRANSITIONS_STYLES,
  RESPONSIVE_STYLES,
};
